const apiEndpoints = {
    SF_data_subscription: {
        local: 'https://d2mntmvdbzmyb.cloudfront.net/v2/preferences',
        uat: 'https://d2mntmvdbzmyb.cloudfront.net/v2/preferences',
        prod: 'https://do1k5b4fpnggr.cloudfront.net/v2/preferences'
    }
}

export default apiEndpoints;
